import ProductPreviewItem from "./PreviewItem";
import React from "react";
import Slider from "react-slick";
import {useMediaQuery} from 'react-responsive';
import {mobileMediaQuery, tabletVerticalMediaQuery} from "../../utils/media-queries";

const PreviewItems = ({title, products, scoreType, imagesBaseUrl, previewItemWidth}) => {
  const isMobile = useMediaQuery(mobileMediaQuery());
  const isTabletV = useMediaQuery(tabletVerticalMediaQuery());
  const viewportWidth = window.innerWidth;
  const numSlidesToShow = isMobile
    ? 2
    : Math.min(4, Math.max(2, Math.ceil(viewportWidth / previewItemWidth)));

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: numSlidesToShow,
    slidesToScroll: 1,
    mobileFirst: true,
    variableWidth: true,
    swipeToSlide: true
  };

  if (isMobile || isTabletV) {
    return (
      <div>
        <div className="product-preview-item-header"><h2>{title}</h2><a href="/produktsuche">Alle ansehen</a></div>
        <Slider {...settings}>
          {products.map(product => (
            <ProductPreviewItem
              key={product.id}
              product={product}
              scoreType={scoreType}
              imagesBaseUrl={imagesBaseUrl}
            />
          ))}
        </Slider>
      </div>
    );
  } else {
    return (
      <div>
        {products.map(product => (
          <ProductPreviewItem
            key={product.id}
            product={product}
            scoreType={scoreType}
            imagesBaseUrl={imagesBaseUrl}
          />
        ))}
      </div>
    );
  }
};

export default PreviewItems;
